// extracted by mini-css-extract-plugin
export var btn = "button-module--btn--57383";
export var dark = "button-module--dark--f61fb";
export var ghost = "button-module--ghost--a7ad7";
export var large = "button-module--large--60541";
export var outline = "button-module--outline--ff5b8";
export var primary = "button-module--primary--76ae4";
export var purple = "button-module--purple--7b8b6";
export var secondary = "button-module--secondary--72bdf";
export var white = "button-module--white--cef0d";
export var xl = "button-module--xl--8dda9";